import React, { useEffect, Suspense } from "react";
import { useDispatch } from "react-redux";
import { loggedIn, loggedOut } from "../../../state/user";
import firebase from "../../../lib/firebase";
import Loader from "../../atomic/Loader/Loader";
import { createGlobalStyle } from "styled-components";
const GlobalStyle = createGlobalStyle`
  .App {
    text-align: center;
  }

  .App-logo {
    height: 40vmin;
  }

  .App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
  }

  .App-link {
    color: #09d3ac;
  }

// global styles
html {
  width: 100%;
  box-sizing: border-box;
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  color: #4d4d4d;
  line-height: 1.15;
  margin: 0;
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
  width: 100%;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  padding: 0;
  margin: 0 0 0px;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: 400;
  color: inherit;
}

button {
  font-family: inherit;
  border: 0;
  padding: 0;
  color: inherit;
}

a {
  text-decoration: underline;
  color: inherit;

  &:hover,
  &:focus {
    text-decoration: none;
  }
}

ul {
  list-style-type: none;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 0;
  color: inherit;
}

a {
  text-decoration: none;
  color: inherit;
}

a:-webkit-any-link {
  text-decoration: none;
}

.scroll-menu-arrow {
  padding: 20px;
  cursor: pointer;
}

.scroll-menu-arrow--disabled {
  display: none;
}

input {
  color: inherit;
}

button {
  -webkit-appearance: button;
  -webkit-writing-mode: horizontal-tb !important;
  text-rendering: auto;
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-indent: 0px;
  text-shadow: none;
  display: inline-block;
  text-align: center;
  align-items: flex-start;
  cursor: default;
  box-sizing: border-box;
  margin: 0em;
  font: 400 11px system-ui;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(216, 216, 216) rgb(209, 209, 209) rgb(186, 186, 186);
  border-image: initial;
  font-family: inherit;
  border: 0;
  padding: 0;
  color: inherit;
}

.react-tags {
  position: relative;
  //  padding: 6px 0 0 6px;
  border: 0px solid #d1d1d1;
  border-radius: 1px;
  //margin: 5px;
  /* shared font styles */
  font-size: 1em;
  line-height: 1.2;
  width: 100%;
  /* clicking anywhere will focus the input */
  cursor: text;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.react-tags.is-focused {
  border-color: #b1b1b1;
}

.react-tags__selected {
  display: inline;
}

.react-tags__selected-tag {
  display: inline-block;
  box-sizing: border-box;
  margin: 0 6px 6px 0;
  padding: 6px 8px;
  border: 1px solid #d1d1d1;
  border-radius: 2px;
  background: #f1f1f1;

  /* match the font styles */
  font-size: inherit;
  line-height: inherit;
}

.react-tags__selected-tag:after {
  content: "\\2715";
  color: #aaa;
  margin-left: 8px;
}

.react-tags__selected-tag:hover,
.react-tags__selected-tag:focus {
  border-color: #b1b1b1;
}
* {
  ::placeholder {
      color: ${props => props.theme.borderColor};
  }
}

label {
  color: ${props => props.theme.fontColor};
}
.react-tags__search {
  display: inline-block;

  /* match tag layout */
  //padding: 7px 2px;
  margin-bottom: 6px;

  /* prevent autoresize overflowing the container */
  width: 100%;
}

@media screen and (min-width: 30em) {
  .react-tags__search {
    /* this will become the offsetParent for suggestions */
    position: relative;
  }
}

hr {
  border-color: ${props => props.theme.borderColor}
}
.react-tags__search-input {
  /* prevent autoresize overflowing the container */
  max-width: 100%;

  /* remove styles and layout from this element */
  margin: 0;
  padding: 0;
  border: 0;
  outline: none;

  /* match the font styles */
  font-size: inherit;
  line-height: inherit;
  padding-right: 5px;

  input {
    width: 100%;
    text-align: end;
    font-size: 15px;
    padding-right: 8px;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    width: 100%;
    border-width: 1px;
    border-style: solid;
    border-radius: 3px;
    border-color: #c1bfb5;
    margin-top: 5px;
    margin-bottom: 5px;
    ::placeholder {
      color: #c1bfb5;
      font-size: 12px;
    }
  }
}

.react-tags__search-input::-ms-clear {
  display: none;
}

.react-tags__suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
}

@media screen and (min-width: 30em) {
  .react-tags__suggestions {
    width: 240px;
  }
}

.react-tags__suggestions ul {
  margin: 4px -1px;
  padding: 0;
  list-style: none;
  background: white;
  border: 1px solid #d1d1d1;
  border-radius: 2px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.react-tags__suggestions li {
  border-bottom: 1px solid #ddd;
  padding: 6px 8px;
}

.react-tags__suggestions li mark {
  text-decoration: underline;
  background: none;
  font-weight: 600;
}

.react-tags__suggestions li:hover {
  cursor: pointer;
  background: #eee;
}

.react-tags__suggestions li.is-active {
  background: #b7cfe0;
}

.react-tags__suggestions li.is-disabled {
  opacity: 0.5;
  cursor: auto;
}
`;

const onMount = dispatch => {
  if (
    window.location.href.substr(0, 5) !== "https" &&
    window.location.href.indexOf("localhost") === -1
  ) {
    window.location.href = window.location.href.replace("http", "https");
    return;
  }
  firebase
    .auth()
    .getRedirectResult()
    .then(function(result) {
      console.log("received result", result);
    })
    .catch(function(error) {
      console.log("redirect error", error);
    });
  firebase.auth().onAuthStateChanged(
    function(user) {
      if (user) {
        // User is signed in.
        var displayName = user.displayName;
        var email = user.email;
        var emailVerified = user.emailVerified;
        var photoURL = user.photoURL;
        var uid = user.uid;
        var phoneNumber = user.phoneNumber;
        var providerData = user.providerData;
        user.getIdToken().then(function(accessToken) {
          dispatch(
            loggedIn({
              displayName: displayName,
              email: email,
              emailVerified: emailVerified,
              phoneNumber: phoneNumber,
              photoURL: photoURL,
              uid: uid,
              accessToken: accessToken,
              providerData: providerData
            })
          );
        });
      } else {
        dispatch(loggedOut());
      }
    },
    function(error) {
      console.log(error);
    }
  );
};

const Base = ({ children }) => {
  const dispatch = useDispatch();
  useEffect(() => onMount(dispatch), [dispatch]);
  return (
    <Suspense fallback={<Loader />}>
      <GlobalStyle />
      <React.Fragment>{children}</React.Fragment>
    </Suspense>
  );
};

export default Base;
